var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteUserIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 28,
    viewBox: "0 0 41 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.25,
    y: 0.5,
    width: 39,
    height: 27,
    rx: 4.5,
    stroke: "#E77B7B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 9.48828C25.0025 9.24078 22.49 9.11328 19.985 9.11328C18.5 9.11328 17.015 9.18828 15.53 9.33828L14 9.48828",
    stroke: "#E77B7B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.125 8.7275L18.29 7.745C18.41 7.0325 18.5 6.5 19.7675 6.5H21.7325C23 6.5 23.0975 7.0625 23.21 7.7525L23.375 8.7275",
    stroke: "#E77B7B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8844 11.8555L25.3969 19.408C25.3144 20.5855 25.2469 21.5005 23.1544 21.5005H18.3394C16.2469 21.5005 16.1794 20.5855 16.0969 19.408L15.6094 11.8555",
    stroke: "#E77B7B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 17.375H21.9975",
    stroke: "#E77B7B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.875 14.375H22.625",
    stroke: "#E77B7B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteUserIcon);
export default __webpack_public_path__ + "static/media/delete_user_icon.29cf1a75a4cb2b7fc32c33bbfa95990a.svg";
export { ForwardRef as ReactComponent };